module.exports = {"411372005":"白河街道","411372006":"枣林街道","411372007":"姜营街道","411372306":"新店乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411372.json
// module id = 1773
// module chunks = 0